import { ControlBoot } from '../../../shared/ui/LoadingState.jsx';
import { DoroPartyWordmark } from '../../../shared/ui/DoroPartyWordmark.jsx';
import { SiteFooter } from '../../../shared/ui/SiteFooter.jsx';
import { SupabaseStatus } from '../../../shared/ui/SupabaseStatus.jsx';
import { PersonalCodeAuthContent } from '../shared/PersonalCodeAuthContent.jsx';
import { BroadcastEntryButton } from '../../broadcast/shared/BroadcastEntryButton.jsx';

export function MobileAuthScreen() {
  return (
    <div className="mobile-auth-shell">
      <header className="mobile-auth-header">
        <div className="mobile-auth-brand"><DoroPartyWordmark compact /><span>유니온 레이드 운영 플랫폼</span></div>
        <SupabaseStatus compact />
      </header>
      <main className="mobile-auth-main">
        <section className="mobile-auth-intro">
          <p className="section-eyebrow">NIKKE UNION RAID PLATFORM</p>
          <h1>개인 코드로 간편하게</h1>
          <p>DC 갤로그 작성자 또는 아카라이브 상태 메시지 인증 후 BlablaLink에서 게임 계정과 소속 유니온을 연결합니다.</p>
        </section>
        <section className="mobile-auth-card" aria-label="DoroParty 개인 코드 인증">
          <PersonalCodeAuthContent mobile />
          <div className="broadcast-auth-entry">
            <div className="broadcast-auth-divider"><span>또는</span></div>
            <BroadcastEntryButton />
          </div>
        </section>
      </main>
      <SiteFooter compact />
    </div>
  );
}

export function MobileAuthLoading() {
  return <ControlBoot stage="session" />;
}
